import {isHiddenOnCurrentDomain} from "@/utils/menuVisible";
import {getTeamFuncStatus} from "@/api/whatsApp.python";

/**
 * 团队套餐相关的store
 */
export default {
    namespaced: true,
    state: {
        packages: {},
        funcPermissions: {}
    },
    getters: {
        getPackageId(state) {
            return state.packages?.package_id;
        },
        getPackageName(state) {
            return state.packages?.name;
        },
        getPackageRemainingDays(state) {
            return state.packages?.remaining_days;
        },
        /**
         * 套餐是否不可用：无套餐，或套餐已过期（remaining_days < 0）
         * 套餐无效，返回 true
         */
        getPackageInvalid(state) {
            if (isHiddenOnCurrentDomain(['joinmc.cn'])) return false;
            return !state.packages?.package_id || Number(state.packages?.remaining_days) < 0;
        },
        /**
         * 返回 plbv 和 whatsapp 群发的权限结果
         * @return {{is_plbv:number; is_whatsapp:number; team_id:string}}
         */
        getFuncPermissions(state) {
            return state.funcPermissions;
        }
    },
    mutations: {
        setPackages(state, data) {
            state.packages = data;
        },
        clearTeamStore(state) {
            state.packages = {};
        },
        SET_FUNC_PERMISSIONS(state, data) {
            state.funcPermissions = data;
        }
    },
    actions: {
        /**
         * 获取团队 plbv 和 whatsapp 群发权限
         * @param param0
         * @param param0.commit
         * @return {Promise<void>}
         */
        async getTeamFuncPermissions({commit}) {
            try {
                const response = await getTeamFuncStatus();
                commit("SET_FUNC_PERMISSIONS", response.data)
            } catch (error) {
                console.error("fetchData error:", error);
                throw error;
            }
        }
    }
}